import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { BUSINESS_URL } from "@util/constant";

/**
 * Component to render Business times section on Partners page
 */
const BusinessTimesSection = (): React.ReactElement => {
  return (
    <div
      className="rounded-tl-lg rounded-tr-lg bg-gray-150"
      data-testid="business-times-section-component"
    >
      <AccordionV2
        testId="business-times"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="The Business Times" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            The Business Times (BT), a member of the SPH Media Limited, is
            South-east Asia&apos;s leading financial daily. BT brings to its
            readers daily corporate, financial, economic and political news,
            analysis and commentary on print and digital platforms. It provides
            readers with in-depth coverage of Singapore and Asian business and
            economic developments, as well as global trends that impact
            Singapore business. BT&apos;s lifestyle journalists bring busy
            executives the latest in recreation, entertainment, the arts,
            design, food and shopping.
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={BUSINESS_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.businesstimes.com.sg
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default BusinessTimesSection;
